import { defineMessages, type MessageDescriptor } from 'react-intl';

// Explicit annotation required by --isolatedDeclarations.
export const messages: Record<string, MessageDescriptor> = defineMessages({
	code: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.code',
		defaultMessage: 'Code',
		description: 'Type label for GitHub code search results.',
	},
	moreActions: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.moreActions',
		defaultMessage: 'More actions',
		description:
			'Tooltip for the icon button beside a code search result title that opens a menu of further actions for that result.',
	},
	moreActionsLabel: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.moreActionsLabel',
		defaultMessage: 'More actions for {scope}',
		description:
			'Accessible label for the icon button beside a code search result title that opens a menu of further actions. There is one such button per result, so the label names the scope its actions apply to. {scope} is a folder path, or a repository name for a file that is not in a folder.',
	},
	openInCodeSearch: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.openInCodeSearch',
		defaultMessage: 'Open in Code Search',
		description:
			'Menu item beside a code search result title that opens the Code Search Portal, where the user can see more matches from the same folder.',
	},
});
